import React, { useMemo, useRef } from "react";
import { Card } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { UserFilter } from "./user-filter/UserFilter";
import { UserTable } from "./user-table/UserTable";
import { useUserUIContext } from "./UserUIContext";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  TOTAL_ACTIVE_USERS_CAP,
  TOTAL_INACTIVE_USERS_CAP,
  TOTAL_USERS_CAP,
  TOTAL_WITHDRAW_REQUESTS_CAP,
} from "../../utils/const";
import NumberFormat from "react-number-format";

export function UserCard({
  isLoading,
  userList,
  userListTotalCount,
  currentPage,
  setCurrentPage,
  handleFilterValues,
  filterValues,
  loadingExportButton,
  exportCSVButton,
  userListExport,
  handleExportButton,
  handleReset,
  countryList,
  statisticsCounterList,
}) {
  const userUIContext = useUserUIContext();
  const userUIProps = useMemo(() => {
    return {
      ids: userUIContext.ids,
      queryParams: userUIContext.queryParams,
      setQueryParams: userUIContext.setQueryParams,
      openReceiptDialog: userUIContext.openReceiptDialog,
    };
  }, [userUIContext]);
  const myRef = useRef(null);
  const onhandleReset = () => {
    myRef.current.click();
  };
  const {
    total_users = "0",
    total_active_users = "0",
    total_inactive_users = "0",
    total_withdraw_request = "0",
  } = statisticsCounterList || {};

  const amountFormatter = (amount) => {
    return (
      <NumberFormat
        value={amount}
        displayType="text"
        thousandSeparator={true}
        prefix="$"
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale={true}
      />
    );
  };

  return (
    <>
      <div className="history-wrapper container dashboard-statistics">
        <div className="row">
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/total-business-users.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {total_users}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_USERS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/active-users.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {total_active_users}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_ACTIVE_USERS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/inactive-users.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {total_inactive_users}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_INACTIVE_USERS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4 d-none">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/withdraw-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(total_withdraw_request)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_WITHDRAW_REQUESTS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">Users</span>
          </h3>
          <button
            type="button"
            className="btn btn-secondary btn-lg"
            onClick={onhandleReset}
          >
            Reset
          </button>
          <button
            className="btn btn-light-primary btn-lg"
            disabled={false}
            onClick={handleExportButton}
          >
            Export
            {loadingExportButton && (
              <span className="ml-1 mr-3 spinner spinner-white"></span>
            )}
          </button>
          <CSVLink
            ref={exportCSVButton}
            className="btn btn-light-primary btn-lg d-none"
            headers={[
              { label: "First Name", key: "firstname" },
              { label: "Last Name", key: "lastname" },
              { label: "Phone Number", key: "cellnumber" },
              { label: "Username", key: "username" },
              { label: "Business Name", key: "business_name" },
              { label: "Account Number", key: "account_number" },
              { label: "Address 1", key: "address_1" },
              { label: "Address 2", key: "address_2" },
              { label: "City", key: "city?.name" },
              { label: "State", key: "state?.state_name" },
              { label: "Country", key: "country?.name" },
              { label: "Last Transaction Date", key: "last_transaction_date" },
            ]}
            data={userListExport ? userListExport : []}
            filename={`users-list-${new Date().getTime()}.csv`}
          >
            Export
          </CSVLink>
        </Card.Header>
        <Card.Body>
          <UserFilter
            filterValues={handleFilterValues}
            countryList={countryList}
            myRef={myRef}
            handleReset={handleReset}
          />
          <UserTable
            isLoading={isLoading}
            filterValues={filterValues}
            userListTotalCount={userListTotalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            userList={userList}
          />
        </Card.Body>
      </Card>
    </>
  );
}
